import { Utilities } from "../../../utils/utilities";

export class DataLoader<T> {
  loaded = false;
  loading = false;
  loadedListeners: DataLoadedListener<T>[] = [];
  data?: T;

  removeListener(listener?: DataLoadedListener<T>) {
    this.loadedListeners = this.loadedListeners.filter((list) => list.id !== listener?.id);
  }

  callListeners() {
    for (const listener of this.loadedListeners) {
      listener.callback(this.data);
    }
  }
}

export class DataLoadedListener<T> {
  id = Utilities.generateUUID();
  loader: DataLoader<T>;
  callback: (docs: T | undefined) => void;
  constructor(callback: (docs: T | undefined) => void, loader: DataLoader<T>) {
    this.callback = callback;
    this.loader = loader;
  }
  removeListener() {
    this.loader.removeListener(this);
  }
}

